import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  GridToolbarContainer,
  GridToolbarExport,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";

/* ---------------- Toolbar ---------------- */
function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

/* ---------------- Pagination ---------------- */
function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination
      color="primary"
      variant="outlined"
      shape="rounded"
      page={page + 1}
      count={pageCount}
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}

/* ---------------- Table Head ---------------- */
const TableHead = [
  {
    field: "customer_id",
    headerName: "ID",
    width: 100,
    headerClassName: "tableHeader",
  },
  {
    field: "customer_full_name",
    headerName: "Name",
    width: 200,
    headerClassName: "tableHeader",
  },
  {
    field: "customer_email_address",
    headerName: "Email",
    width: 220,
    headerClassName: "tableHeader",
  },
  {
    field: "customer_mobile_no",
    headerName: "Mobile",
    width: 160,
    headerClassName: "tableHeader",
  },
];

/* ---------------- Component ---------------- */
function AddNotificationTable(props) {
  return (
    <div className="w-full h-[500px] pr-5">
      <div className="bg-white rounded-xl shadow-md border border-gray-200 h-full">
        <DataGrid
          rows={props?.list?.map((customer) => ({
            ...customer,
            id: customer?.customer_id,
          }))}
          columns={TableHead}
          pageSizeOptions={[5]}
          checkboxSelection
          onRowSelectionModelChange={(ls) => props?.setUserList(ls)}
          components={{
            Toolbar: CustomToolbar,
            Pagination: CustomPagination,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
          onCellClick={(event) => {
            event.defaultMuiPrevented = true;
          }}
          sx={{
            border: 0,
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f9fafb", // Tailwind gray-50
              fontWeight: 600,
              fontSize: "0.875rem",
              color: "#374151", // gray-700
            },
            "& .MuiDataGrid-cell": {
              fontSize: "0.875rem",
              color: "#374151",
            },
            "& .MuiDataGrid-cell:hover": {
              color: "#1d4ed8", // blue-700
              backgroundColor: "#eff6ff", // blue-50
              cursor: "pointer",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "1px solid #e5e7eb", // gray-200
              backgroundColor: "#fafafa",
            },
            "& .MuiDataGrid-row.Mui-selected": {
              backgroundColor: "#dbeafe !important", // blue-100
              "&:hover": {
                backgroundColor: "#bfdbfe !important", // blue-200
              },
            },
          }}
        />
      </div>
    </div>
  );
}

export default AddNotificationTable;
